import React, { useState } from 'react'
import WhatsappImg from '../subcomponetnts/contactImages/whatsapp.png'
import phoneImg from '../subcomponetnts/contactImages/old-typical-phone.png';
import emailImg from '../subcomponetnts/contactImages/email.png'
import CopyComponent from '../../../../components/copyComponent';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import flags from 'emoji-flags';
import CountryFlag from './countryflag';

export default function Contactpopup({ activeContact }) {
    const { countryArray } = useSelector((state) => state.uidata);

    const { client_email = '', client_phone = "", client_whatsapp = "", client_country = "" } = activeContact
    const [countryCode, setCountryCode] = useState('');

 


    useEffect(() => {
        if (client_country !== "") {
            let filtered = countryArray.filter((data) => data.country_name == client_country)
            setCountryCode(filtered[0].country_code);
        }

    }, [activeContact])
    return (
        <div className="confirm-delete-wrapper register-medium">
            <div data-backdrop="static" className="modal fade" id={'Contactpopup'} role="dialog">
                <div className="modal-dialog padding-unset modal-dialog-preview">
                    <div className="modal-content">
                        <div className="cross-icon-popup-1 position-relative">
                            <img src="localImages/crossicon.png" onClick={() => window.loadModal2("#Contactpopup", "hide")} />
                        </div>
                        <div className="modal-body">
                            {console.log(countryArray, "countryArray")}
                            <h3>Contact Info
                                {/* <br />
                                (Country {client_country} - {countryCodeToFlag(countryCode)}) */}
                            </h3>

                            <div className="contactbox-container ">
                                {client_country !== "" && <div className='contactbox-wrapper contactbox-contact-country'>
                                   
                                  <span className='w-20-px'>  <CountryFlag countryCode={countryCode} /></span> 
                                    <a className='contactbox-contact pl-2' href={`javascript:void();`}>
                                        {client_country}
                                    </a>
                                    {/* <span>{client_phone}</span> */}
                                    {/* <CopyComponent value={client_country} /> */}
                                </div>}
                                {client_phone !== "" && <div className='contactbox-wrapper'>
                                    <img className='w-20-px' src={phoneImg} alt='whatsapp' />
                                    <a className='contactbox-contact' href={`tel:+${client_phone}`}>+{client_phone}</a>
                                    {/* <span>{client_phone}</span> */}
                                    <CopyComponent value={client_phone} />
                                </div>}
                                {client_whatsapp !== "" && <div className='contactbox-wrapper'>
                                    <img className='w-20-px' src={WhatsappImg} alt='whatsapp' />
                                    {/* <span>{client_whatsapp}</span> */}
                                    <a className='contactbox-contact' target='_blank' href={`https://wa.me/${client_whatsapp}`}>+{client_whatsapp}</a>
                                    <CopyComponent value={client_whatsapp} />
                                </div>}
                                {client_email !== "" && <div className='contactbox-wrapper'>
                                    <img className='w-20-px' src={emailImg} alt='whatsapp' />
                                    {/* <span>{client_email}</span> */}
                                    <a
                                        className='contactbox-contact'
                                        href={`mailto:${client_email}`}>
                                        {client_email}
                                    </a>
                                    <CopyComponent value={client_email} />
                                </div>}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
